import type { ReactNode } from 'react';

import { ta } from './messages';
import type { InvitationRole } from './schemas';

export type InvitationSummaryProps = {
  tenantName: string;
  campaignName: string | null;
  role: InvitationRole;
  invitedByEmail: string | null;
};

const ROLE_MESSAGE_KEYS: Record<InvitationRole, 'role.TENANT_ADMIN' | 'role.CAMPAIGN_ANALYST'> = {
  TENANT_ADMIN: 'role.TENANT_ADMIN',
  CAMPAIGN_ANALYST: 'role.CAMPAIGN_ANALYST',
};

export function InvitationSummary(props: InvitationSummaryProps): ReactNode {
  return (
    <dl className="flex flex-col gap-3 rounded-lg bg-muted p-4">
      <div className="flex flex-col gap-1 sm:flex-row sm:justify-between sm:gap-4">
        <dt className="shrink-0 text-body-sm text-muted-foreground">{ta('label.organisation')}</dt>
        <dd className="min-w-0 text-body-sm font-medium text-foreground text-left break-words sm:text-right">
          {props.tenantName}
        </dd>
      </div>

      {props.campaignName !== null && (
        <div className="flex flex-col gap-1 sm:flex-row sm:justify-between sm:gap-4">
          <dt className="shrink-0 text-body-sm text-muted-foreground">{ta('label.campaign')}</dt>
          <dd className="min-w-0 text-body-sm font-medium text-foreground text-left break-words sm:text-right">
            {props.campaignName}
          </dd>
        </div>
      )}

      <div className="flex flex-col gap-1 sm:flex-row sm:justify-between sm:gap-4">
        <dt className="shrink-0 text-body-sm text-muted-foreground">{ta('label.role')}</dt>
        <dd className="min-w-0 text-body-sm font-medium text-foreground text-left break-words sm:text-right">
          {ta(ROLE_MESSAGE_KEYS[props.role])}
        </dd>
      </div>

      {props.invitedByEmail !== null && (
        <div className="flex flex-col gap-1 sm:flex-row sm:justify-between sm:gap-4">
          <dt className="shrink-0 text-body-sm text-muted-foreground">{ta('label.inviter')}</dt>
          <dd className="min-w-0 text-body-sm font-medium text-foreground text-left break-words sm:text-right">
            {props.invitedByEmail}
          </dd>
        </div>
      )}
    </dl>
  );
}
